/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import {all} from 'redux-saga/effects';
import {watchHome} from './home';
import {watchStep} from './step';
import {watchSearch} from './search';

export default function* () {
  yield all([
    watchHome(),
    watchStep(),
    watchSearch()
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js